import React from "react";
import "./articles.css";
import { content } from "../../content/landingContent";

const ArticleCard = ({ title, description, icon: Icon, link }) => {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="article-card"
      onClick={handleClick}
      role={link ? "link" : undefined}
      tabIndex={link ? 0 : undefined}
      onKeyDown={
        link
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleClick();
              }
            }
          : undefined
      }
    >
      <div className="article-content">
        <div
          style={{ fontSize: "2.5rem", color: "white", marginBottom: "1rem" }}
        >
          <Icon />
        </div>
        <h3 className="article-title">{title}</h3>
        <p className="article-description">{description}</p>
      </div>
    </div>
  );
};

const Articles = () => {
  const { heading, tagline, cards } = content.articles;

  return (
    <section id="articles">
      <div className="articles-section">
        <div className="articles-heading">{heading}</div>

        <div className="articles-grid">
          {cards.map((card) => (
            <ArticleCard
              key={card.title}
              title={card.title}
              description={card.description}
              icon={card.icon}
              link={card.link}
            />
          ))}
        </div>

        {tagline ? <p className="articles-tagline">{tagline}</p> : null}
      </div>
    </section>
  );
};

export default Articles;
